import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { ConfigGroup } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { ConfigItem } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigItem';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { APPComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { MDAConstant } from '../../Base/MDAConstant';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointConfigGroupShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointConfigGroupShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_ConfigGroup.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(configGroupShape: NodeShape, configGroup: ConfigGroup, isFromJSON: boolean) {
    if (configGroup) {
      MDExtendService.setElementListSequence(configGroup.configItems, false);
    }
    this.setBaseMD(configGroupShape, this.createModel(configGroup, !configGroupShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_CONFIGGROUP;
  }

  get configGroup(): ConfigGroup {
    return this.element() as ConfigGroup;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加配置项
      case 'shape:addConfigItem':
        element = this.addConfigItem();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  private addConfigItem(): ConfigItem {
    const item = MDRepository.createConfigItem(this.configGroup);
    MDExtendService.setElementListSequence(this.configGroup.configItems, true);
    this.model().compartments[0].push(item);
    return item;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.configGroup.configItems.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.configGroup.configItems.splice(this.configGroup.configItems.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(configGroup: ConfigGroup, isCollapse = false): ShapeModel {
    const model = new ShapeModel(configGroup, isCollapse);
    model.addCompartment(configGroup.configItems.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointConfigGroupShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new ConfigGroup();
    newElement.copyFrom(this.configGroup, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof APPComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.configGroups.push(newElement);
    }

    this.configGroup.configItems.forEach(item => {
      const configItem = new ConfigItem();
      configItem.copyFrom(item, false);
      MDExtendService.setCreateInfo(configItem);
      configItem.configGroup_ID = newElement.id;
      newElement.configItems.push(configItem);
      elements.push(configItem);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): ConfigItem | null {
    let newElement: ConfigItem | null = null;
    if (element instanceof ConfigItem) {
      newElement = new ConfigItem();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.configGroup_ID = this.configGroup.id;
      this.configGroup.configItems.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 配置分组
   *    - 必须包含至少一个配置项
   * 2. 配置项
   *    - 配置项必须填写名称
   *    - 配置项必须填写显示名称
   *    - 不允许为空，必须填写缺省值
   *    - 不能存在同名配置项
   *    - 数据类型不能使用引用类型
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.configGroup.designId;
    MDValidation.validateBaseElement(this.configGroup, this.configGroup.designId, true, errors);
    if (this.configGroup.configItems.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `配置分组 [${this.configGroup.displayName}] 必须包含至少一个配置项`));
    } else {
      this.configGroup.configItems.forEach(element => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if (!element.isNullable && !ValidateHelper.IsNotNullOrEmpty(element.defaultValue)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Warning, containerDesignId, element.designId, `配置分组 [${this.configGroup.displayName}] 的配置项 [${element.displayName}] 不允许为空，必须填写缺省值`));
        }
        if (this.configGroup.configItems.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `配置分组 [${this.configGroup.displayName}] 不能存在同名配置项 [${element.name}]`));
        }
        if (element.dataType === EnumDataType.Reference) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `配置分组 [${this.configGroup.displayName}] 的配置项 [${element.displayName}] 不能设置为引用类型`));
        }
      });
    }
    return errors;
  }
}
